<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="18" 
    height="18" 
    viewBox="0 0 18 18" 
    fill="none"
  >
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" d="M5.46967 3.96967C5.76256 3.67678 6.23744 3.67678 6.53033 3.96967L8.78033 6.21967C9.07322 6.51256 9.07322 6.98744 8.78033 7.28033C8.48744 7.57322 8.01256 7.57322 7.71967 7.28033L6.75 6.31066V13.5C6.75 13.9142 6.41421 14.25 6 14.25C5.58579 14.25 5.25 13.9142 5.25 13.5V6.31066L4.28033 7.28033C3.98744 7.57322 3.51256 7.57322 3.21967 7.28033C2.92678 6.98744 2.92678 6.51256 3.21967 6.21967L5.46967 3.96967Z" :fill="color"
    />
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M12.5303 14.0303C12.2374 14.3232 11.7626 14.3232 11.4697 14.0303L9.21967 11.7803C8.92678 11.4874 8.92678 11.0126 9.21967 10.7197C9.51256 10.4268 9.98744 10.4268 10.2803 10.7197L11.25 11.6893L11.25 4.5C11.25 4.08579 11.5858 3.75 12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5L12.75 11.6893L13.7197 10.7197C14.0126 10.4268 14.4874 10.4268 14.7803 10.7197C15.0732 11.0126 15.0732 11.4874 14.7803 11.7803L12.5303 14.0303Z" 
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#FFF"
    }
  }
}
</script>